import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Helper function to wrap class base component to get access to location and navigate react-router hooks
 *
 * @param Component
 *
 */

export const withRouter = (Component) => {
    return function WrapperComponent(props) {
        const location = useLocation(),
            navigate = useNavigate();
        return <Component {...props} location={location} navigate={navigate} />;
    };
};
